export const updateCheckoutNote = (resposive) => ({
    type: 'UPDATE_CHECKOUT_NOTES',
    payload: resposive
});

export const updateCheckoutDeliveryDate = (resposive) => ({
    type: 'UPDATE_CHECKOUT_DELDATE',
    payload: resposive
});

export const updateCheckoutCard = (resposive) => ({
    type: 'UPDATE_CHECKOUT_CARD',
    payload: resposive
});

export const resetCheckout = () => ({
    type: 'RESET_CHECKOUT'
})